<script>
  import Icon from '../../Icon/Icon.svelte';

  export let subscription, isMostPopular;

  const getLocalizationValue = (usps) =>
    usps.map((usp) => subscription.informationKeys[usp]).filter(Boolean);

  const allUsp = getLocalizationValue([
    'payment.usp.one.text.v2',
    'payment.usp.two.text.v2',
    'payment.usp.three.text.v2',
    'payment.usp.four.text.v2',
  ]);
</script>

<style lang="scss">
  @use './styles/sharedStyles' as *;
  @use '../index' as *;

  .card {
    @include generalCardStyle;
  }

  .subscription-description-list {
    list-style-type: none;
    color: $purple-80;
    fill: $purple-80;
    margin-block-start: -0.8rem;
    padding-block-end: spacing(2);

    @include mq($from: desktop) {
      margin-block-start: 0;
    }

    :global(svg) {
      margin-block-start: spacing(0.5);
    }

    .list-item {
      display: grid;
      grid-template-columns: spacing(3) auto;
      margin-block-end: spacing(1);

      &:last-child {
        margin-block-end: 0;
      }
    }
  }
</style>

<ul class="card subscription-description-list" class:most-popular-border={isMostPopular}>
  {#each allUsp as usp}
    <li class="list-item">
      <Icon iconName="checkmark" size="16" />
      {@html usp}
    </li>
  {/each}
</ul>
